import  React,{ useEffect, useRef, useState } from "react";

const SkillsSearchDropdown = ({ value, onChange, onBlur, skillsList }) => {
  const initialValue = Array.isArray(value) ? value : value ? value?.split(",") : [];
  const [inputValue, setInputValue] = useState('');
  const [selectedSkills, setSelectedSkills] = useState(initialValue);
  const [suggestions, setSuggestions] = useState([]);
  const [showSuggestions, setShowSuggestions] = useState(false);
  const inputRef = useRef(null);
  const suggestionsRef = useRef(null);


  useEffect(() => {
    const handleClickOutside = (event) => {
      if (suggestionsRef.current && !suggestionsRef.current.contains(event.target)) {
        setShowSuggestions(false);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, [selectedSkills]);

  useEffect(() => {
    const skillsArray = Array.isArray(value) ? value : value?.split(",");

    const mappedSkills = skillsArray.map(skill => {
      if (typeof skill === 'object' && skill.skill_id) {
        return skill;
      }
      const foundSkill = skillsList.find(s => s.skill_id === skill);
      return foundSkill || null;
    }).filter(Boolean);

    setSelectedSkills(mappedSkills);
  }, []);

  const handleInputChange = (e) => {
    const value = e.target.value;
    setInputValue(value);

    if (value.trim()) {
      const filtered = skillsList.filter(skill => {
        const searchTerm = value.toLowerCase();
        const alreadySelected = selectedSkills.some(selected => selected.skill_id === skill.skill_id);

        return !alreadySelected && (skill.skill_name.toLowerCase().includes(searchTerm) || skill.skill_shortname.toLowerCase().includes(searchTerm) || skill.skill_tag.toLowerCase().includes(searchTerm));
      });
      setSuggestions(filtered);
      setShowSuggestions(true);
    } else {
      setSuggestions([]);
      setShowSuggestions(false);
    }
  };

  const addSkill = (skill) => {
    if (!selectedSkills.some(selected => selected.skill_id === skill.skill_id)) {
      const newSkills = [...selectedSkills, skill];
      setSelectedSkills(newSkills);
      onChange(newSkills);
      setInputValue('');
      setSuggestions([]);
      setShowSuggestions(false);
    }
  };

  const removeSkill = (skillToRemove) => {
    const newSkills = selectedSkills.filter(skill => skill.skill_id !== skillToRemove.skill_id);
    setSelectedSkills(newSkills);
    onChange(newSkills);
  };

  const handleKeyDown = (e) => {
    if (e.key === 'Enter' && inputValue.trim() !== '') {
      e.preventDefault();
      if (suggestions.length > 0) {
        addSkill(suggestions[0]);
      }
    }
  };

  const renderSkillBadge = (skill) => {
    const tags = skill?.skill_tag?.split(',').slice(0, 2).map(tag => tag.trim());
    return (
      <span
        key={skill.skill_id}
        className="badge bg-primary me-2 mb-2 d-inline-flex align-items-center rounded-3 p-2"
      >
        <span className="d-flex flex-column">
          <span>{skill.skill_name}</span>
          {/* <small className="text-white-50">
            {tags?.join(' • ')}
          </small> */}
        </span>
        <button
          type="button"
          className="btn-close btn-close-white ms-2"
          style={{fontSize: '0.5rem'}}
          onClick={() => removeSkill(skill)}
          aria-label="Remove skill"
        />
      </span>
    );
  };

  const renderSuggestionItem = (skill) => {
    return (
      <div
        key={skill.skill_id}
        className="p-2 cursor-pointer hover-bg-light"
        style={{cursor: 'pointer'}}
        onMouseDown={() => addSkill(skill)}
      >
        <div className="d-flex flex-column">
          <span className="fw-medium">{skill.skill_name} - {skill.skill_shortname} - {skill.skill_category}</span>
          {/* <small className="text-muted">
            
          </small> */}
          {/* <small className="text-muted">
            Tags: {skill.skill_tag}
          </small> */}
        </div>
      </div>
    );
  };

  return (<div className="skills-autocomplete">
    <div className="mb-2">
      {selectedSkills.map(renderSkillBadge)}
    </div>
    <div className="position-relative">
      <input
        type="text"
        ref={inputRef}
        className="form-control"
        value={inputValue}
        onChange={handleInputChange}
        onKeyDown={handleKeyDown}
        onBlur={() => {
          setTimeout(() => setShowSuggestions(false), 200);
          // onBlur?.();
        }}
        placeholder="Search skills by name, shortname, or tags..."
      />
      {showSuggestions && suggestions.length > 0 && (<div
          ref={suggestionsRef}
          className="position-absolute w-100 mt-1 shadow bg-white rounded border"
          style={{
            zIndex: 1000, maxHeight: '200px', overflowY: 'auto'
          }}
        >
          {suggestions.map(renderSuggestionItem)}
        </div>
      )}
    </div>
  </div>);
};

export default SkillsSearchDropdown;